import styled from 'styled-components';
import { COLORS } from 'assets/styled';

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 10; // Above ImageMagnifier
  display: flex;
  flex-direction: column;
  gap: 20rem;
  align-items: center;
  justify-content: center;
`;

export const OverlayText = styled.p`
  margin: 0;
  max-width: 480rem;
  padding: 10rem 20rem;
  border-radius: 10rem;
  background-color: ${COLORS.WHITE};
  font-size: 18rem;
  line-height: 27rem;
  font-weight: 300;
  color: ${COLORS.BLACK};
  text-align: center;
`;
